'use strict';

const FOCUSABLE = 'button:not(:disabled):not([aria-hidden]),a[href],input,[tabindex="0"]';

function focuseOnModal (selector, focusOnClose, selectorfadeOut) {
    $(selector).on('keydown', function(event) {
        let focusableNodes = $(selector).find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
        const key = event.which;
        const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
        if (event.shiftKey && focusedItemIndex === 0) {
            focusableNodes[focusableNodes.length - 1].focus();
            event.preventDefault();
        }
        if (!event.shiftKey && focusableNodes.length > 0 && focusedItemIndex === focusableNodes.length - 1 && key !== 13) {
            focusableNodes[0].focus();
            event.preventDefault();
        }
        if (key === 27) { // close popUp on ESC
            // re-activate background elements if previously disabled
            if ($(document.body).is('[aria-hidden="true"][aria-disabled="true"]')) {
                $(document.body).removeAttr('aria-hidden aria-disabled');
            }

            // $(selectorfadeOut).fadeOut();
            $(selectorfadeOut).addClass('d-none');
            setTimeout(function() {
                $(focusOnClose).focus();
            }, 0);
            if ($('body').hasClass('cc-blocked')) $('body').removeClass('cc-blocked');
            if ($('body').hasClass('veiled')) $('body').removeClass('veiled');
        }
    });
};

function trapFocus(element) {
    $(element).trigger('keydown');
}

function iterateFocusOnPage() {
    $('body').on('keydown', function(event) {
        let focusableNodes = $('body').find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
        const key = event.which;
        const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
        if (event.shiftKey && focusedItemIndex === 0) {
            focusableNodes[focusableNodes.length - 1].focus();
            event.preventDefault();
        }
        if (!event.shiftKey && focusableNodes.length > 0 && focusedItemIndex === focusableNodes.length - 1 && key !== 13) {
            focusableNodes[0].focus();
            event.preventDefault();
        }
    });
};

function focusOnFirstElement(selector) {
    $(selector).find(FOCUSABLE).each(function() {
        if ($(this).hasClass('d-none')) {
            return true;
        } else {
            $(this).focus();
            return false;
        }
    });
};

function disableBackgroundElements(selector) {
    // accessibility: disable everything on page except the modal content
    $(document.body).attr({
        'aria-hidden': 'true',
        'aria-disabled': 'true'
    });

    $(selector).attr({
        'aria-hidden': 'false',
        'aria-disabled': 'false'
    });
};

module.exports = {
    focuseOnModal: focuseOnModal,
    iterateFocusOnPage: iterateFocusOnPage,
    focusOnFirstElement: focusOnFirstElement,
    trapFocus: trapFocus,
    disableBackgroundElements: disableBackgroundElements
};
